/**
 * CheckOutlineIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const CheckOutlineIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      d="M1 12C1 5.925 5.925 1 12 1a11 11 0 0 1 11 11c0 6.075-4.925 11-11 11S1 18.075 1 12m20 0a9 9 0 1 0-18 0 9 9 0 0 0 18 0"
      clipRule="evenodd"
    />
    <path d="m8.45 11.65 2.15 2.15 4.95-4.95a.95.95 0 0 1 .7-.275q.425 0 .7.275a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7L11.3 15.9q-.3.3-.7.3a.96.96 0 0 1-.7-.3l-2.85-2.85a.95.95 0 0 1-.275-.7q0-.424.275-.7a.95.95 0 0 1 .7-.275q.425 0 .7.275" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const CheckOutlineIcon = makeIcon('CheckOutlineIcon', CheckOutlineIconSvg)
